import { NgModule } from '@angular/core';
import {SlideToggleComponent} from './slide-toggle.component';
import {NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {CommonModule} from '@angular/common';


@NgModule({
  imports: [
    NgbTooltipModule,
    FontAwesomeModule,
    CommonModule,
  ],
  declarations: [
    SlideToggleComponent
  ],
  exports: [
    SlideToggleComponent
  ]
})
export class SlideToggleModule { }
